export default __webpack_public_path__ + "static/exit_light_w.a75ceb3291af6b11f93e32cd12e15025.svg";